import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/BasketLog`;

//testtt
const ApiBasketLog = {
  getBasketLog: (params) => {
    const data = {
      BasketId: parseInt(params.BasketId) ? parseInt(params.BasketId) : '',
      BasketItemId: parseInt(params.BasketItemId) ? parseInt(params.BasketItemId) : '',
      BasketPersonId: parseInt(params.BasketPersonId) ? parseInt(params.BasketPersonId) : '',
      BasketItemPersonId: parseInt(params.BasketItemPersonId) ? parseInt(params.BasketItemPersonId) : '',
      PageSize: parseInt(params.PageSize) ? parseInt(params.PageSize) : ''
    }
    const url = `${baseServiceUrl}/getBasketLog?BasketId=` + parseInt(data.BasketId) +
      '&BasketItemId=' + data.BasketItemId +
      '&BasketPersonId=' + data.BasketPersonId +
      '&BasketItemPersonId=' + data.BasketItemPersonId +
      '&PageSize=' + data.PageSize;

    return ServiceApi.get(url, params);
  },
  postDescrib: (data) => {
    const url = `${baseServiceUrl}/CreateBasketLog`;
    return ServiceApi.post(url, data)
  },
};

export default ApiBasketLog;